import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-53824660"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "jiaoshou"
};
const _hoisted_2 = {
  key: 0,
  class: "panel"
};
const _hoisted_3 = {
  class: "panel-title"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "交收报表", -1));

const _hoisted_5 = {
  style: {
    "text-align": "center"
  }
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode("返回");

const _hoisted_7 = {
  key: 0,
  class: "title"
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode("返回上一级");

const _hoisted_9 = {
  class: "panel-body"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  key: 2
};
const _hoisted_13 = {
  key: 3
};
const _hoisted_14 = {
  key: 4
};
const _hoisted_15 = {
  key: 5
};
const _hoisted_16 = {
  key: 6
};
const _hoisted_17 = {
  key: 7
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  key: 0,
  class: "zhi-i",
  title: "直屬會員"
};

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_21 = {
  type: "danger"
};
const _hoisted_22 = {
  key: 0
};
const _hoisted_23 = {
  key: 1
};

const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_26 = {
  class: "paging"
};
const _hoisted_27 = {
  class: "other-total"
};

const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 占成结果： ");

const _hoisted_29 = /*#__PURE__*/_createTextVNode("  /  赚赔差： ");

const _hoisted_30 = /*#__PURE__*/_createTextVNode("  / 赚取退水： ");

const _hoisted_31 = /*#__PURE__*/_createTextVNode("  /  ");

const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "primary-color"
}, "补货结果：", -1));

const _hoisted_33 = /*#__PURE__*/_createTextVNode("  /  ");

const _hoisted_34 = /*#__PURE__*/_createTextVNode("抵扣补货及赚水赔率差后结果");

const _hoisted_35 = /*#__PURE__*/_createTextVNode("抵扣补货及赚水后结果");

const _hoisted_36 = /*#__PURE__*/_createTextVNode("： ");

const _hoisted_37 = /*#__PURE__*/_createTextVNode("  /  ");

const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 与上级交收： ");

const _hoisted_39 = /*#__PURE__*/_createTextVNode("  /  应收下线： ");

const _hoisted_40 = {
  key: 1,
  class: "panel"
};
const _hoisted_41 = {
  class: "panel-title"
};

const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "注单明细", -1));

const _hoisted_43 = /*#__PURE__*/_createTextVNode("返回");

const _hoisted_44 = {
  class: "panel-body"
};
const _hoisted_45 = {
  key: 2,
  class: "panel"
};
const _hoisted_46 = {
  class: "panel-title"
};

const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "外补注额明细", -1));

const _hoisted_48 = /*#__PURE__*/_createTextVNode("返回");

const _hoisted_49 = {
  class: "panel-body"
};
const _hoisted_50 = {
  class: "paging"
};
const _hoisted_51 = {
  key: 0,
  style: {
    "width": "50%",
    "margin": "10px auto 0 auto"
  }
};
const _hoisted_52 = {
  key: 0
};
const _hoisted_53 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");

  const _component_el_link = _resolveComponent("el-link");

  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_tooltip = _resolveComponent("el-tooltip");

  const _component_el_table = _resolveComponent("el-table");

  const _component_el_pagination = _resolveComponent("el-pagination");

  const _component_zhudanmingxi = _resolveComponent("zhudanmingxi");

  const _component_gameDetail = _resolveComponent("gameDetail");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.dialog.visible == '报表' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString($props.search_title_info), 1), _createVNode(_component_el_button, {
    style: {
      "float": "right",
      "margin": "3px"
    },
    size: "small",
    onClick: $options.back_search
  }, {
    default: _withCtx(() => [_hoisted_6]),
    _: 1
  }, 8, ["onClick"])]), $data.back_list.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_button, {
    type: "warning",
    size: "small",
    icon: "el-icon-arrow-left",
    onClick: $options.get_back_list
  }, {
    default: _withCtx(() => [_hoisted_8]),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_table, {
    ref: "tableRef",
    data: $data.data_list,
    border: "",
    size: "small",
    "highlight-current-row": "",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row",
    "show-summary": "",
    "summary-method": $options.baobiao_sum,
    "cell-class-name": $options.cellClassName
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "username",
      align: "center",
      label: "级别",
      "min-width": "60px"
    }, {
      header: _withCtx(() => [$data.total.group_id == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_10, "大总监")) : _createCommentVNode("", true), $data.total.group_id == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_11, "总监")) : _createCommentVNode("", true), $data.total.group_id == 4 ? (_openBlock(), _createElementBlock("span", _hoisted_12, "分公司")) : _createCommentVNode("", true), $data.total.group_id == 5 ? (_openBlock(), _createElementBlock("span", _hoisted_13, "大股东")) : _createCommentVNode("", true), $data.total.group_id == 6 ? (_openBlock(), _createElementBlock("span", _hoisted_14, "股东")) : _createCommentVNode("", true), $data.total.group_id == 7 ? (_openBlock(), _createElementBlock("span", _hoisted_15, "总代理")) : _createCommentVNode("", true), $data.total.group_id == 8 ? (_openBlock(), _createElementBlock("span", _hoisted_16, "代理")) : _createCommentVNode("", true), $data.total.group_id == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_17, "会员")) : _createCommentVNode("", true)]),
      default: _withCtx(scope => [scope.row.group_id === '0' ? (_openBlock(), _createElementBlock("span", _hoisted_18, [_createTextVNode(_toDisplayString(scope.row.username), 1), scope.row.is_zhishu == '1' ? (_openBlock(), _createElementBlock("span", _hoisted_19, "直")) : _createCommentVNode("", true)])) : (_openBlock(), _createBlock(_component_el_link, {
        key: 1,
        type: "success",
        onClick: $event => $options.search_sub(scope.row)
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.username), 1)]),
        _: 2
      }, 1032, ["onClick"]))]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "real_name",
      label: "名称",
      align: "center",
      "min-width": $data.width.real_name.minwidth
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.real_name), 1)]),
      _: 1
    }, 8, ["min-width"]), _createVNode(_component_el_table_column, {
      prop: "bet_count",
      label: "笔数",
      align: "center",
      "min-width": $data.width.bet_count.minwidth
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.bet_count), 1)]),
      _: 1
    }, 8, ["min-width"]), _createVNode(_component_el_table_column, {
      prop: "sum_bet",
      label: "总投注额",
      align: "center",
      "min-width": $data.width.sum_bet.minwidth
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_link, {
        onClick: $event => $options.search_detail(scope.row)
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.sum_bet), 1)]),
        _: 2
      }, 1032, ["onClick"])]),
      _: 1
    }, 8, ["min-width"]), _createVNode(_component_el_table_column, {
      prop: "balance",
      label: "有效金额",
      align: "center",
      "min-width": $data.width.balance.minwidth
    }, null, 8, ["min-width"]), _createVNode(_component_el_table_column, {
      prop: "hy_shuyin",
      label: "会员输赢",
      align: "center",
      "min-width": $data.width.hy_shuyin.minwidth
    }, null, 8, ["min-width"]), _createVNode(_component_el_table_column, {
      prop: "receive_subline",
      label: "应收下线",
      align: "center",
      "min-width": $data.width.receive_subline.minwidth
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_tooltip, {
        placement: "top"
      }, {
        content: _withCtx(() => [_createTextVNode(" 输赢：" + _toDisplayString(scope.row.balance - scope.row.bonus) + " ", 1), _hoisted_20, _createTextVNode(" 退水：" + _toDisplayString(scope.row.rebate), 1)]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_21, _toDisplayString(scope.row.receive_subline), 1)]),
        _: 2
      }, 1024)]),
      _: 1
    }, 8, ["min-width"]), _createVNode(_component_el_table_column, {
      prop: "sup_occupy_lock",
      label: "实占成数",
      align: "center",
      width: "60"
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.kuaicai_sup_occupy_lock) + "% ", 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "occu_balance",
      label: "实占注额",
      align: "center",
      "min-width": $data.width.occu_balance.minwidth
    }, null, 8, ["min-width"]), _createVNode(_component_el_table_column, {
      prop: "bonus",
      label: "占货比",
      align: "center",
      width: "47"
    }, {
      default: _withCtx(scope => [$data.total.occu_balance == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_22, "0")) : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString((scope.row.occu_balance / $data.total.occu_balance * 100).toFixed(0)), 1))]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "occu_winlose",
      label: "实占输赢",
      align: "center",
      "min-width": $data.width.occu_winlose.minwidth
    }, {
      default: _withCtx(scope => [_createElementVNode("div", null, [_createVNode(_component_el_tooltip, {
        placement: "top"
      }, {
        content: _withCtx(() => [_createTextVNode(" 输赢：" + _toDisplayString(scope.row.user_winlose) + " ", 1), _hoisted_24, scope.row.group_id > 0 && scope.row.group_id < 5 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode(" 赚赔：" + _toDisplayString(scope.row.eran - scope.row.trader_eran) + " ", 1), _hoisted_25, _createTextVNode(" 操盘赚赔：" + _toDisplayString(scope.row.trader_eran), 1)], 64)) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(scope.row.occu_winlose), 1)]),
        _: 2
      }, 1024)])]),
      _: 1
    }, 8, ["min-width"]), _createVNode(_component_el_table_column, {
      prop: "occu_rebate",
      label: "实占退水",
      align: "center",
      "min-width": $data.width.occu_rebate.minwidth
    }, null, 8, ["min-width"]), _createVNode(_component_el_table_column, {
      prop: "real_occupy_result",
      label: "实占结果",
      align: "center",
      "min-width": $data.width.real_occupy_result.minwidth
    }, null, 8, ["min-width"]), _createVNode(_component_el_table_column, {
      prop: "earn_rebate",
      label: "赚取退水",
      align: "center",
      "min-width": $data.width.earn_rebate.minwidth
    }, null, 8, ["min-width"]), _ctx.$store.state.userinfo.group_id == 1 || _ctx.$store.state.userinfo.group_id == 4 || _ctx.$store.state.userinfo.group_id == 5 ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 0,
      prop: "own_eran",
      label: "赚取赔差",
      align: "center",
      width: "60"
    })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
      prop: "real_result",
      label: "退水后结果",
      align: "center",
      "min-width": $data.width.real_result.minwidth
    }, null, 8, ["min-width"]), _createVNode(_component_el_table_column, {
      prop: "cont_sup",
      label: "贡献上级",
      align: "center",
      "min-width": $data.width.cont_sup.minwidth
    }, null, 8, ["min-width"]), _createVNode(_component_el_table_column, {
      prop: "receive_supline",
      label: "应付上级",
      align: "center",
      "min-width": $data.width.receive_supline.minwidth
    }, null, 8, ["min-width"])]),
    _: 1
  }, 8, ["data", "summary-method", "cell-class-name"]), _createElementVNode("div", _hoisted_26, [_createVNode(_component_el_pagination, {
    small: "",
    onCurrentChange: $options.change_page,
    modelValue: $data.page,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.page = $event),
    "page-size": 40,
    "pager-count": 5,
    total: $data.pagination.total_records * 1,
    layout: "total,prev,pager,next,jumper",
    "hide-on-single-page": ""
  }, null, 8, ["onCurrentChange", "modelValue", "total"])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", null, [_hoisted_28, _createElementVNode("span", {
    class: _normalizeClass($data.total.occupy_result < 0 ? 'redcolor' : '')
  }, _toDisplayString($data.total.occupy_result), 3), _ctx.$store.state.userinfo.group_id < 6 && $data.total.own_eran != 0 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_hoisted_29, _createElementVNode("span", {
    class: _normalizeClass($data.total.own_eran < 0 ? 'redcolor' : '')
  }, _toDisplayString($data.total.own_eran), 3)], 64)) : _createCommentVNode("", true), _hoisted_30, _createElementVNode("span", {
    class: _normalizeClass($data.total.earn_rebate < 0 ? 'redcolor' : '')
  }, _toDisplayString($data.total.earn_rebate), 3), $data.autolet[0].result != 0 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_hoisted_31, _hoisted_32, _createVNode(_component_el_link, {
    type: $data.autolet[0].result > 0 ? 'danger' : 'primary',
    onClick: _cache[1] || (_cache[1] = $event => $options.get_buhuo_detail('', '1'))
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.autolet[0].result), 1)]),
    _: 1
  }, 8, ["type"])], 64)) : _createCommentVNode("", true), _hoisted_33, $data.total.group_id == 3 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_hoisted_34], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 3
  }, [_hoisted_35], 64)), _hoisted_36, _createElementVNode("span", {
    class: _normalizeClass($data.total.result < 0 ? 'redcolor' : '')
  }, _toDisplayString($data.total.result * 1), 3), _hoisted_37, $data.total.p_own_eran_result != undefined ? (_openBlock(), _createElementBlock("span", {
    key: 4,
    class: _normalizeClass($data.total.p_own_eran_result < 0 ? 'redcolor' : '')
  }, "赚赔后总结果：" + _toDisplayString($data.total.p_own_eran_result) + "  / ", 3)) : _createCommentVNode("", true), _hoisted_38, _createElementVNode("span", {
    class: _normalizeClass($data.total.total_receive_supline < 0 ? 'redcolor' : '')
  }, _toDisplayString($data.total.total_receive_supline), 3), _hoisted_39, _createElementVNode("span", {
    class: _normalizeClass($data.autolet[0].sum_receive_subline < 0 ? 'redcolor' : '')
  }, _toDisplayString($data.autolet[0].sum_receive_subline), 3)])])])])) : _createCommentVNode("", true), $data.dialog.visible == '注单明细' ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_hoisted_42, _createVNode(_component_el_button, {
    style: {
      "float": "right",
      "margin": "3px"
    },
    size: "small",
    onClick: $options.close_balance
  }, {
    default: _withCtx(() => [_hoisted_43]),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_44, [_createVNode(_component_zhudanmingxi, {
    ref: "zhudanmingxi",
    from: '交收报表',
    rowinfo: $data.rowinfo,
    form: $props.form,
    gameClassID: $data.game_detail_data.dialogDetailGameClassID,
    isGetBuHuoDetail: $data.isGetBuHuoDetail
  }, null, 8, ["rowinfo", "form", "gameClassID", "isGetBuHuoDetail"])])])) : _createCommentVNode("", true), $data.dialog.visible == '外补注额明细' ? (_openBlock(), _createElementBlock("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_hoisted_47, _createVNode(_component_el_button, {
    style: {
      "float": "right",
      "margin": "3px"
    },
    size: "small",
    onClick: $options.close_balance
  }, {
    default: _withCtx(() => [_hoisted_48]),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_49, [_createVNode(_component_el_table, {
    data: $data.bh.data_list,
    border: "",
    size: "small",
    "highlight-current-row": "",
    "min-height": "500",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      property: "qnum",
      label: "期号",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "posttime",
      label: "时间",
      align: "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_ctx.$filters.time(scope.row.posttime)), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      property: "method",
      label: "玩法",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "rate",
      label: "赔率",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "rebate",
      label: "退水",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "control_let",
      label: "补货金额",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "let_res",
      label: "补货结果",
      align: "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("span", {
        class: _normalizeClass(scope.row.let_res < 0 ? 'redcolor' : '')
      }, _toDisplayString(scope.row.let_res), 3)]),
      _: 1
    })]),
    _: 1
  }, 8, ["data"]), _createElementVNode("div", _hoisted_50, [_createVNode(_component_el_pagination, {
    small: "",
    onCurrentChange: $options.get_out_buhuo_detail,
    modelValue: $data.bh.page,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.bh.page = $event),
    "page-size": 10,
    "pager-count": 5,
    total: $data.bh.pagination.total_records * 1,
    layout: "total,prev,pager,next,jumper"
  }, null, 8, ["onCurrentChange", "modelValue", "total"])])])])) : _createCommentVNode("", true), $data.dialog.visible == '报表' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 3
  }, [$data.autolet[0].num > 0 || $props.show_waibu && $data.autolet[0].sum_out_balance > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_51, [_createVNode(_component_el_table, {
    data: $data.autolet,
    border: "",
    size: "small",
    "highlight-current-row": ""
  }, {
    default: _withCtx(() => [$data.autolet[0].num > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createVNode(_component_el_table_column, {
      property: "num",
      label: "补货笔数",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "sum_balance",
      label: "补货金额",
      align: "center"
    }, {
      default: _withCtx(scope => [scope.row.sum_balance == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(scope.row.sum_balance), 1)) : (_openBlock(), _createBlock(_component_el_link, {
        key: 1,
        type: "primary",
        onClick: _cache[3] || (_cache[3] = $event => $options.get_buhuo_detail())
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.sum_balance), 1)]),
        _: 2
      }, 1024))]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      property: "let_balance",
      label: "补货输赢",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "rebate_balance",
      label: "退水",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "result",
      label: "退水后结果",
      align: "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("span", {
        class: _normalizeClass(scope.row.result < 0 ? 'redcolor' : '')
      }, _toDisplayString(scope.row.result), 3)]),
      _: 1
    })], 64)) : _createCommentVNode("", true), $props.show_waibu && $data.autolet[0].sum_out_balance > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createVNode(_component_el_table_column, {
      property: "sum_out_count",
      label: "外补笔数",
      align: "center"
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.sum_out_count), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      property: "sum_out_balance",
      label: "外补注额",
      align: "center"
    }, {
      default: _withCtx(scope => [scope.row.sum_out_balance == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(scope.row.sum_out_balance), 1)) : (_openBlock(), _createBlock(_component_el_link, {
        key: 1,
        type: "primary",
        onClick: _cache[4] || (_cache[4] = $event => $options.get_out_buhuo_detail(1))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.sum_out_balance), 1)]),
        _: 2
      }, 1024))]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      property: "sum_out_rebate",
      label: "外补退水",
      align: "center"
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.sum_out_rebate), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      property: "sum_out_bonus",
      label: "外补输赢",
      align: "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("span", {
        class: _normalizeClass(scope.row.sum_out_bonus < 0 ? 'redcolor' : '')
      }, _toDisplayString(scope.row.sum_out_bonus), 3)]),
      _: 1
    })], 64)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["data"])])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), $data.dialog.visible == '报表' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 4
  }, [$props.game_list.length > 1 ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "game_detail_data-btn",
    onClick: _cache[5] || (_cache[5] = (...args) => $options.get_game_detail_data && $options.get_game_detail_data(...args))
  }, _toDisplayString($data.game_detail_data.text), 1)) : _createCommentVNode("", true), $data.game_detail_data.open ? (_openBlock(), _createBlock(_component_gameDetail, {
    key: 1,
    form: $props.form,
    list: $data.game_detail_data.list,
    onSearch_sub: $options.search_sub,
    onSearch_detail: $options.search_detail
  }, null, 8, ["form", "list", "onSearch_sub", "onSearch_detail"])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]);
}